// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getServicios as listServiciosAPI,
    getServicio as getServicioAPI,
    addServicio as addServicioAPI,
    updateServicio as updateServicioAPI,
    deleteServicio as deleteServicioAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { serviciosApiResponseError, serviciosApiResponseSuccess } from './actions';
import { ServiciosActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getServicio({ payload: { id } }) {
    try {
        const response = yield call(getServicioAPI, id );
        const servicioItem = response.data.data;
        yield put(serviciosApiResponseSuccess(ServiciosActionTypes.GET_SERVICIO, servicioItem));
    } catch (error) {
        yield put(serviciosApiResponseError(ServiciosActionTypes.GET_SERVICIO, error));
    }
}

function* addServicio({payload:servicio}){
    try{
        const response = yield call(addServicioAPI,{...servicio})
        const servicioItem = response.data
        yield put(serviciosApiResponseSuccess(ServiciosActionTypes.ADD_SERVICIO,servicioItem))
    } catch(error){
        yield put(serviciosApiResponseError(ServiciosActionTypes.ADD_SERVICIO,error))
    }
}

function* updateServicio({payload:servicio}){
    try{
        const response = yield call(updateServicioAPI,{...servicio})
        const servicioItem = response.data.data
        yield put(serviciosApiResponseSuccess(ServiciosActionTypes.UPDATE_SERVICIO,servicioItem))
    }catch(error){
        yield put(serviciosApiResponseError(ServiciosActionTypes.UPDATE_SERVICIO,error))
    }
}
function* deleteServicio({payload:{id}}){
    try{
        const response = yield call(deleteServicioAPI,id)
        const servicioItem = response.data.id
        yield put(serviciosApiResponseSuccess(ServiciosActionTypes.DELETE_SERVICIO,servicioItem))
    }catch(error){
        yield put(serviciosApiResponseError(ServiciosActionTypes.DELETE_SERVICIO,error))
    }
}

/**
 * List contactos
 */
function* listServicios({payload:params}) {
    try {
        const response = yield call(listServiciosAPI, { ...params });
        const listaServicios = response.data.data;
        yield put(serviciosApiResponseSuccess(ServiciosActionTypes.LIST_SERVICIOS, listaServicios));
    } catch (error) {
        yield put(serviciosApiResponseError(ServiciosActionTypes.LIST_SERVICIOS, error));
    }
}


export function* watchGetServicio(): any {
    yield takeEvery(ServiciosActionTypes.GET_SERVICIO, getServicio);
}

export function* watchListServicios(): any {
    yield takeEvery(ServiciosActionTypes.LIST_SERVICIOS, listServicios);
}

export function* watchAddServicio():any{
    yield takeEvery(ServiciosActionTypes.ADD_SERVICIO,addServicio)
}
export function* watchUpdateServicio():any{
    yield takeEvery(ServiciosActionTypes.UPDATE_SERVICIO,updateServicio)
}
export function* watchDeleteServicio():any{
    yield takeEvery(ServiciosActionTypes.DELETE_SERVICIO,deleteServicio)
}


function* serviciosSaga(): any {
    yield all([
        fork(watchGetServicio),
        fork(watchListServicios),
        fork(watchAddServicio),
        fork(watchUpdateServicio),
        fork(watchDeleteServicio),
    ]);
}

export default serviciosSaga;
